import { ArticleAuthorBio, ArticleTags } from '@/components/common/Article'
import { Newsletter } from '@/components/common/Newsletter'
import { usePage } from '@/components/providers/PageProvider'

import styles from './GuideFooter.module.scss'

export const GuideFooter = () => {
  const { page } = usePage()
  const article = page?.article

  if (!article) return null

  return (
    <footer className={styles.container}>
      <ArticleTags tags={article.tags} />
      <ArticleAuthorBio author={article.author} colorScheme='strong' />
      <Newsletter contained />
    </footer>
  )
}
